/**
 * HangarX Growth OS SDK
 * Track events, analyze growth, and optimize conversions
 * 
 * @packageDocumentation
 */

import { HangarX as HangarXClass } from './hangarx'
export { HangarX } from './hangarx'
export type { HangarXConfig, EventData, UserTraits } from './hangarx'

// Default export for UMD builds
export default HangarXClass

// Auto-initialize from window.hangarxConfig if present (for script tag usage)
if (typeof window !== 'undefined') {
  const config = (window as any).hangarxConfig
  if (config && config.apiKey) {
    // Auto-initialize and expose globally
    (window as any).hangarx = new HangarXClass(config)
  }
}

